import { FilterModel } from "./filter.model";
import { HistoryModel } from "./history.model";
import { FileModel } from "./file.model";

export class UserModel {

  userUid: number;
  email: string;
  deviceUid: number;
  sessionId: string;
  clientUid: number;
  userRoleUid: number;
  userRoleName: string;
  permissionUids: number[];

  testDeviceSerialNumber: string;
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  addressOne: string;
  addressTwo: string;
  city: string;
  postCode: string;
  userRoleSelect: FilterModel;

  history: Array<HistoryModel> = [];
  files: Array<FileModel> = [];
  
  constructor() 
  {
    
  }
}